import { DateTime } from 'luxon';

export default function getExpiryDateStyleColor(expiryDate: string): string {
	const dayDiff =
		DateTime.fromISO(expiryDate).diff(DateTime.now(), 'days').toObject()
			.days || 0;
	if (DateTime.fromISO(expiryDate) < DateTime.now()) {
		return '#FF0000';
	} else if (dayDiff < 30) {
		return '#FF8C00';
	}
	return '#768D95';
}
